import { useRef } from "react";
import { untracked } from "mobx";

export function normalizeLatchedEditorId(value) {
  return String(value ?? "").trim().toLowerCase() || null;
}

export function readEditorPersistedSnapshot(entity) {
  return untracked(() => {
    if (!entity) {
      return false;
    }

    if (entity?.isPersisted === true) {
      return true;
    }

    return Number(entity?._rev ?? 0) > 0;
  });
}

export function resolveLatchedEditorPersistedSession(
  currentSession,
  { editorId, entity } = {},
) {
  const normalizedEditorId = normalizeLatchedEditorId(editorId);

  if (!normalizedEditorId) {
    return null;
  }

  if (currentSession?.editorId === normalizedEditorId) {
    return currentSession;
  }

  return {
    editorId: normalizedEditorId,
    openedAsPersisted: readEditorPersistedSnapshot(entity),
  };
}

export function readLatchedEditorPersistedState(
  currentSession,
  { editorId, entity } = {},
) {
  const normalizedEditorId = normalizeLatchedEditorId(editorId);

  if (!normalizedEditorId) {
    return false;
  }

  if (currentSession?.editorId === normalizedEditorId) {
    return currentSession.openedAsPersisted === true;
  }

  return readEditorPersistedSnapshot(entity);
}

export function useLatchedEditorPersistedState(editorId, entity) {
  const normalizedEditorId = normalizeLatchedEditorId(editorId);
  const sessionRef = useRef(null);
  const nextSession = resolveLatchedEditorPersistedSession(sessionRef.current, {
    editorId: normalizedEditorId,
    entity,
  });

  if (sessionRef.current !== nextSession) {
    sessionRef.current = nextSession;
  }

  return readLatchedEditorPersistedState(sessionRef.current, {
    editorId: normalizedEditorId,
    entity,
  });
}
